"use strict";
exports.__esModule = true;
var clients_1 = require("../clients");
var BlueAPI = /** @class */ (function () {
    function BlueAPI(debug, config) {
        // this.gatewayClient = new GatewayClient(debug, {
        //   gatewayUrl: config.gateway.gatewayUrl,
        //   edition: config.gateway.edition,
        //   goods: config.gateway.goods,
        //   terrace: config.gateway.terrace,
        // });
        if (debug === void 0) { debug = true; }
        // this.blueClient = new BlueClient(debug, {
        //   blueUrl: config.blue.blueUrl,
        //   secretKey: config.blue.secretKey,
        // });
        // this.toolsClient = new ToolsClient(debug, {
        //   toolsUrl: config.tools.toolsUrl,
        // });
        this.blueGatewayClient = new clients_1.BlueGatewayClient(debug, {
            gatewayUrl: config.gateway.gatewayUrl,
            edition: config.gateway.edition,
            goods: config.gateway.goods,
            terrace: config.gateway.terrace
        });
    }
    /**
     * 微信js sdk 参数
     * @param url 应用域名
     */
    BlueAPI.prototype.getJSSDKConfig = function (currUrl) {
        return this.blueGatewayClient.jsapiTicket(currUrl);
    };
    BlueAPI.prototype.setToken = function (token) {
        this.blueGatewayClient.setToken(token);
    };
    BlueAPI.prototype.removeToken = function () {
        this.blueGatewayClient.removeToken();
    };
    /**
     * 获取code的Url
     * @param url
     */
    BlueAPI.prototype.getWechatCodeUrl = function (codeUrl) {
        return this.blueGatewayClient.getCodeUrl(codeUrl);
    };
    /**
     * 获取openId
     * @param code
     */
    BlueAPI.prototype.getWechatOpenId = function (code) {
        return this.blueGatewayClient.getOpenId(code);
    };
    BlueAPI.prototype.login = function (phone, password, source, openId) {
        if (source === void 0) { source = 0; }
        if (openId === void 0) { openId = ''; }
        return this.blueGatewayClient.login(phone, password, source, openId);
    };
    BlueAPI.prototype.updateOpenId = function (ownerId, openId) {
        if (openId === void 0) { openId = ''; }
        return this.blueGatewayClient.updateOpenId(ownerId, openId);
    };
    BlueAPI.prototype.loginOut = function (ownerId, openId) {
        if (openId === void 0) { openId = ''; }
        return this.blueGatewayClient.loginOut(ownerId, openId);
    };
    /**
     * 获取业主报表
     * @param roomId 查询房间ID
     */
    BlueAPI.prototype.ownerReportHome = function (roomId, ownerId) {
        return this.blueGatewayClient.ownerReportHome(roomId, ownerId);
    };
    /**
     * 业主详情
     */
    BlueAPI.prototype.ownerDetail = function (id) {
        return this.blueGatewayClient.ownerDetail(id);
    };
    /**
     * 查询业主的合同接口
     * @param ownerId 业主Id
     * @param signed 签约状态
     */
    BlueAPI.prototype.findContractForWechat = function (ownerId, signed) {
        return this.blueGatewayClient.findContractForWechat(ownerId, signed);
    };
    /**
     * 线上合同创建
     * @param ownerId 业主ID
     * @param createName 创建人
     * @param foreignIds 房间测评ID集合
     */
    BlueAPI.prototype.ContractOnlineForWechat = function (ownerId, createName, foreignIds, signCity, signDate, token) {
        return this.blueGatewayClient.ContractOnlineForWechat(ownerId, createName, foreignIds, signCity, signDate, token);
    };
    /**
     * 根据合同ID查询房间测评接口
     * @param contractOnlineId 合同ID
     */
    BlueAPI.prototype.findByContractOnlineId = function (contractOnlineId) {
        return this.blueGatewayClient.findByContractOnlineId(contractOnlineId);
    };
    /**
     * 线上合同修改接口-微信端
     * @param modifyContractOnlineId 修改线上合同
     */
    BlueAPI.prototype.modifyContractOnlineId = function (modifyContractOnlineId) {
        return this.blueGatewayClient.modifyContractOnlineId(modifyContractOnlineId);
    };
    /**
     * 查询评测历史（分页）
     * @param ownerId 蓝主人ID
     * @param size 每页记录数
     * @param page 从1开始
     */
    BlueAPI.prototype.roomEvaluationHistory = function (ownerId, size, page, token) {
        return this.blueGatewayClient.roomEvaluationHistory(ownerId, size, page);
    };
    /**
     * 删除评测历史
     * @param roomEvaluationId 房间测评ID
     */
    BlueAPI.prototype.deleteRoomEvaluationHistory = function (roomEvaluationId) {
        return this.blueGatewayClient.deleteRoomEvaluationHistory(roomEvaluationId);
    };
    /**
     * 查询蓝主人历史楼宇
     * @param ownerId 蓝主人ID
     */
    BlueAPI.prototype.buildingHistory = function (ownerId) {
        return this.blueGatewayClient.buildingHistory(ownerId);
    };
    /**
     * 查询所有广告
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网)
     */
    BlueAPI.prototype.findAllAdvert = function (terminal) {
        return this.blueGatewayClient.findAllAdvert(terminal);
    };
    /**
     * 业主日结账单列表
     * @param page 开始行
     * @param rows 每页显示数量
     * @param startDate 查询开始时间
     * @param ownerId 业主Id
     * @param endDate 查询截止时间
     */
    BlueAPI.prototype.findOwnerReportByDay = function (page, rows, startDate, ownerId, endDate) {
        return this.blueGatewayClient.findOwnerReportByDay(page, rows, startDate, ownerId, endDate);
    };
    /**
     * 业主日结账单详情
     * @param ownerId 业主Id
     * @param curDate 查询日期
     */
    BlueAPI.prototype.findOwnerDayReport = function (ownerId, curDate, roomIdList) {
        return this.blueGatewayClient.findOwnerDayReport(ownerId, curDate, roomIdList);
    };
    /**
     * 业主所属房间日结账单列表
     * @param ownerId 业主Id
     * @param curDate 查询日期
     * @param page 开始行
     * @param rows 每页显示条数
     */
    BlueAPI.prototype.findOwnerRoomDayReport = function (ownerId, curDate, page, rows) {
        return this.blueGatewayClient.findOwnerRoomDayReport(ownerId, curDate, page, rows);
    };
    /**
     * 业主月结账单列表
     * @param rows 每页显示条数
     * @param page 开始行
     * @param ownerId 业主Id
     */
    BlueAPI.prototype.findOwnerReportByMonth = function (rows, page, ownerId) {
        return this.blueGatewayClient.findOwnerReportByMonth(rows, page, ownerId);
    };
    /**
     * 业主月结账单详情
     * @param ownerId 业主Id
     * @param yearMonth 查询月份
     */
    BlueAPI.prototype.findOwnerMonthReport = function (ownerId, curYearMonth, roomIdList) {
        return this.blueGatewayClient.findOwnerMonthReport(ownerId, curYearMonth, roomIdList);
    };
    /**
     * 房间月结账单详情
     * @param ownerId 业主Id
     * @param xbedRoomId xbed房间Id
     * @param curYearMonth 查询月份
     */
    BlueAPI.prototype.findRoomMonthReport = function (ownerId, xbedRoomId, curYearMonth) {
        return this.blueGatewayClient.findRoomMonthReport(ownerId, xbedRoomId, curYearMonth);
    };
    /**
     * 房间月结账单明细
     * @param ownerId 业主Id
     * @param rows 每页显示条数
     * @param curYearMonth 查询月份
     * @param page 开始行
     * @param roomId xbed房间Id
     */
    BlueAPI.prototype.findRoomMonthReportDetail = function (ownerId, rows, curYearMonth, page, roomId) {
        return this.blueGatewayClient.findRoomMonthReportDetail(ownerId, rows, curYearMonth, page, roomId);
    };
    /**
     * 房间月结账单列表
     * @param page 开始行
     * @param rows 每页显示条数
     * @param curYearMonth 月份
     * @param roomIdList 房间Id
     * @param ownerId 业主Id
     */
    BlueAPI.prototype.findRoomReportByMonth = function (page, rows, curYearMonth, roomIdList, ownerId) {
        return this.blueGatewayClient.findRoomReportByMonth(page, rows, curYearMonth, roomIdList, ownerId);
    };
    /**
     * 根据业主ID获取活动列表+未参加的信息
     */
    BlueAPI.prototype.activityList = function (ownerId) {
        return this.blueGatewayClient.activityList(ownerId);
    };
    /**
     * 更新活动/卡券的读状态
     * @param ownerId  用户id
     * @param activityId  活动id
     * @param couponCardId  卡券id
     */
    BlueAPI.prototype.updateReadStatus = function (ownerId, activityId, couponCardId) {
        return this.blueGatewayClient.updateReadStatus(ownerId, activityId, couponCardId);
    };
    /**
     * 通过活动或者卡券的ID+蓝主人ID查询已参加、已拒绝的列表
     * @param couponCardId 卡券ID
     * @param ownerId 蓝主人ID
     * @param activityId 活动ID
     */
    BlueAPI.prototype.getMarketingById = function (couponCardId, ownerId, activityId) {
        return this.blueGatewayClient.getMarketingById(couponCardId, ownerId, activityId);
    };
    /**
     * 增加不参加活动/卡券的房间
     * @param roomIds 多个房间的ID房间，多个房间逗号分隔
     * @param activityId 活动ID
     * @param ownerId 蓝主人ID
     * @param couponCardId 卡券ID
     */
    BlueAPI.prototype.moreExcludeRoom = function (roomIds, activityId, ownerId, couponCardId) {
        return this.blueGatewayClient.moreExcludeRoom(roomIds, activityId, ownerId, couponCardId);
    };
    /**
     * 增加参加活动/卡券的房间
     * @param ownerId 蓝主人ID
     * @param activityId 活动ID
     * @param roomIds 房间，多个房间逗号分隔
     * @param couponCardId 卡券ID
     */
    BlueAPI.prototype.moreIncludeRoom = function (ownerId, activityId, roomIds, couponCardId) {
        return this.blueGatewayClient.moreIncludeRoom(ownerId, activityId, roomIds, couponCardId);
    };
    /**
     * 取风格列表
     */
    BlueAPI.prototype.listMore = function () {
        return this.blueGatewayClient.listMore();
    };
    /**
     * 取主题下的模板
     */
    BlueAPI.prototype.getThemeModule = function (themeId) {
        return this.blueGatewayClient.getThemeModule(themeId);
    };
    /**
     * 取业主的房间
     */
    BlueAPI.prototype.getOwnerRoom = function (ownerId) {
        return this.blueGatewayClient.getOwnerRoom(ownerId);
    };
    /**
     * 根据标签搜索业主房间
     */
    BlueAPI.prototype.getOwnerRoomTagSearch = function (ownerId, tagCnameWay) {
        return this.blueGatewayClient.getOwnerRoomTagSearch(ownerId, tagCnameWay);
    };
    /**
     * 根据标签搜索业主房间
     */
    BlueAPI.prototype.getOwnerRoomTagList = function (ownerId, tagCname) {
        return this.blueGatewayClient.getOwnerRoomTagList(ownerId, tagCname);
    };
    /**
     * 取业主的房间
     */
    BlueAPI.prototype.getRoomInfo = function (ownerId) {
        return this.blueGatewayClient.getRoomInfo(ownerId);
    };
    /**
     * 房间详请获取停用单列表
     * @param rows 页大小
     * @param page 当前页
     * @param roomId 蓝主人房间Id
     */
    BlueAPI.prototype.findStopListByRoomId = function (rows, page, roomId) {
        return this.blueGatewayClient.findStopListByRoomId(rows, page, roomId);
    };
    /**
     * 查看入住单详情（业主）
     * @param checkinId 入住单Id
     * @param ownerId 业主Id(蓝主人端传递)
     */
    BlueAPI.prototype.checkinOrderInfo = function (checkinId, ownerId) {
        return this.blueGatewayClient.checkinOrderInfo(checkinId, ownerId);
    };
    /**
     * 查询业主预订单列表
     * @param page 页码
     * @param type 类型
     * @param ownerId 业主Id(蓝主人端传递)
     * @param size 页大小
     */
    BlueAPI.prototype.ownerOrderList = function (param) {
        return this.blueGatewayClient.ownerOrderList(param);
    };
    /**
     * 查询订单列表（业主）
     * @param type 类型
     * @param size 页大小
     * @param ownerId 业主Id(蓝主人端传递)
     * @param page 页码
     */
    BlueAPI.prototype.orderList = function (param) {
        return this.blueGatewayClient.orderList(param);
    };
    /**
     * 根据orderNo取消申请业主自用单
     * @param orderNo 自用单orderNo
     */
    BlueAPI.prototype.cancleByOrderNo = function (orderNo) {
        return this.blueGatewayClient.cancleByOrderNo(orderNo);
    };
    /**
     * 获取开门密码
     * @param checkinId 入住单Id
     */
    BlueAPI.prototype.ownerSelfCheckin = function (checkinId) {
        return this.blueGatewayClient.ownerSelfCheckin(checkinId);
    };
    /**
     * 结束自用单
     * @param checkinId 入住单Id
     * @param roomId 房间Id
     */
    BlueAPI.prototype.ownerSelfCheckout = function (checkinId, roomId) {
        return this.blueGatewayClient.ownerSelfCheckout(checkinId, roomId);
    };
    /**
     * 业主自用单详情
     * @param orderNo 订单号
     * @param checkinId 入住单Id
     */
    BlueAPI.prototype.ownerSelfOrderInfo = function (orderNo, checkinId) {
        return this.blueGatewayClient.ownerSelfOrderInfo(orderNo, checkinId);
    };
    /**
     * 查询业主自用单列表
     * @param phone 手机号码
     * @param type 类型
     * @param size 页大小
     * @param page 页码
     */
    BlueAPI.prototype.ownerSelfOrderList = function (param, token) {
        return this.blueGatewayClient.ownerSelfOrderList(param, token);
    };
    /**
     * 生成业主订单
     * @param cardCode 使用卡券code(非必传参数)
     * @param name 用户下单时填写的称呼
     * @param roomTypeId 打包房型id
     * @param commandName 口令姓名
     * @param rentType 租房类型
     * @param arrivalTime 预计到达时间。非必传
     * @param commandPhone 口令手机
     * @param activityId 指定执行活动id(如果不想选择活动就传递-1)
     * @param beginDate 订单开始时间
     * @param roomId 多个房间数组或逗号隔开
     * @param xdollar Xdollar的数量(非必传参数)
     * @param isPackage 是否为打包房型下单(1:是0:否)
     * @param command 口令
     * @param endDate 订单结束时间
     */
    BlueAPI.prototype.createOwnerOder = function (param, token) {
        return this.blueGatewayClient.createOwnerOder(param, token);
    };
    /**
     * 获取免审次数
     * @param roomId 房间Id
     */
    BlueAPI.prototype.getRestrictionTimes = function (roomId, token) {
        return this.blueGatewayClient.getRestrictionTimes(roomId, token);
    };
    /**
     * 获取短信验证码
     * @param phone 手机号码
     * @param isText 是否是文字。true-文字
     */
    BlueAPI.prototype.getVerificationCode = function (phone, isText) {
        return this.blueGatewayClient.getVerificationCode(phone, isText);
    };
    /**
     * 房间测评图片批量上传接口(删除旧的，保存新的)
     * @param ownerImgInfoArrayStr 数组名称  只传这个数组，其他的都是数组内每个对象的属性
     * @param foreignId 对应的测评id或者合同id
     * @param createName 创建人
     * @param mediaId 微信图片编号
     * @param tableType 1表示测评，2表示合同
     * @param imgType 图片类型
     * @param imgUrl 图片url路径
     */
    BlueAPI.prototype.batAddEvaluationImg = function (ownerImgInfoArrayStr) {
        return this.blueGatewayClient.batAddEvaluationImg(ownerImgInfoArrayStr);
    };
    /**
     * 金融服务 新增
     * @param province 省
     * @param name 姓名
     * @param district 区
     * @param address 街道地址
     * @param city 市
     * @param mobile 手机
     * @param ltype 类型
     */
    BlueAPI.prototype.Lender = function (params) {
        return this.blueGatewayClient.Lender(params);
    };
    /**
     * 金融服务 新增平安投保人和房间
     * @param certificateNo 证件号码
     * @param certificateType 证件类型固定为01
     * @param mobileTelephone 手机号码
     * @param name 投保人姓名
     * @param ownerId 业主id
     * @param roomIdArray 房间id列表，逗号分割
     */
    BlueAPI.prototype.addPingAn = function (certificateNo, certificateType, mobileTelephone, name, ownerId, roomIdArray) {
        return this.blueGatewayClient.addPingAn(certificateNo, certificateType, mobileTelephone, name, ownerId, roomIdArray);
    };
    /**
     * 修改业主
     * @param bankAccount 银行账号
     * @param bankUser 开户名
     * @param type 账户性质:1个人，2企业
     * @param email 邮箱
     * @param address 详细地址
     * @param gender 性别
     * @param id 业主id
     * @param province 省份
     * @param mobile 手机号码
     * @param developerId 开发者Id（下拉列表取id传进来）
     * @param clubId 俱乐部Id
     * @param city 城市
     * @param isMaker 是否创客：1是，0否（必传）
     * @param district 区
     * @param bankName 开户银行名称
     * @param name 姓名
     */
    BlueAPI.prototype.ModifyOwner = function (params, token) {
        return this.blueGatewayClient.Owner(params, token);
    };
    /**
     * 图片新增接口
     * @param foreignId 对应的测评id或者合同id
     * @param imgType 图片类型：1卧室图，2房屋其它区域图，3房产证，4租赁合同，5本人签名图，6甲方身份证正面，7甲方身份证反面，8转账截图
     * @param imgUrl 图片url路径
     * @param imgCode base64编码
     * @param tableType 1表示测评，2表示合同
     * @param createName 创建人
     */
    BlueAPI.prototype.addOwnerImgInfo = function (params, token) {
        return this.blueGatewayClient.OwnerImgInfo(params, token);
    };
    /**
     * 甲方身份证认证
     * @param cardBackMediaId	身份证背面	string
     * @param cardFrontMediaId	身份证正面	string
     * @param contractOnlineId	合同ID	number
     * @param createName	创建人	string
     */
    BlueAPI.prototype.OwnerAuthImg = function (params) {
        return this.blueGatewayClient.OwnerAuthImg(params);
    };
    /**
     * 图片查询接口
     * @param foreignId 对应的测评id或者合同id
     * @param tableType 1表示测评，2表示合同
     */
    BlueAPI.prototype.getOwnerImgInfo = function (foreignId, tableType) {
        return this.blueGatewayClient.OwnerImgInfoQuery(foreignId, tableType);
    };
    /**
     * 个人中心身份验证接口
     * @param cardFrontMediaId 身份证正面图
     * @param id 业主ID
     * @param businessLicenseMediaId 营业执照图
     * @param cardBackMediaId 身份证背面图
     */
    BlueAPI.prototype.UpImageAuthentication = function (params) {
        return this.blueGatewayClient.authentication(params);
    };
    /**
     * 保存房间测评信息
     * @param roomStructure 房屋结构:1标准平层，2复式结构，3别墅，4四合院
     * @param isElevator 是否有电梯：1是，0否
     * @param studyNum 书房数量
     * @param kitchenNum 厨房数量
     * @param city 市
     * @param createName 创建人
     * @param roomName 房间号
     * @param hallNum 大厅数量
     * @param floor 所在楼层
     * @param yardNum 院子数量
     * @param softCondition 软装条件：1无家具，2需补充/调整家具，3酒店客房标准，4自住家具标准
     * @param limitType 出入限制:1门禁卡/钥匙，2前台/门卫登记，3出入无限制
     * @param area 面积，单位㎡
     * @param status 默认：1。测评状态：1未签约，2已签约，3业主删除
     * @param address 详细地址
     * @param salesmanName 业务员名称
     * @param busDistanceType 公交车站距离类型：1：0~500m，2：500~1000m，3：1000m以上
     * @param province 省
     * @param salesmanPhone 业务员联系方式
     * @param updateName 修改人
     * @param buildYear 建成年份
     * @param isTraffic 1km内是否有公共交通站点，1是，0否
     * @param ownerId 蓝主人ID
     * @param toiletNum 卫生间数量
     * @param buildingType 楼宇性质,1商住楼，2民宅楼，3办公楼，4综合楼，5其他
     * @param appearance 公共外观:1崭新，2较新，3一般，4老旧
     * @param updateDate 修改时间
     * @param district 区
     * @param subwayDistanceType 地铁站距离类型：1：0~500m，2：500~1000m，3：1000m以上
     * @param houseType 房源类型：1租赁房间，2自有房间
     * @param contractOnlineId 不要传。线上合同ID
     * @param buildingName 楼宇名称
     * @param balconyNum 阳台数量
     * @param bedroomNum 卧室数量
     * @param bedNum 床铺数量
     * @param hardCondition 硬装条件：1毛坯房，2需装修，3简装，4精装，5豪装
     */
    BlueAPI.prototype.RoomEvaluation = function (params) {
        return this.blueGatewayClient.RoomEvaluation(params);
    };
    /**
     * 查询合同证件图
     * @param contractOnlineId 线上合同ID
     */
    BlueAPI.prototype.getCertiflcatesImg = function (contractOnlineId) {
        return this.blueGatewayClient.getCertiflcatesImg(contractOnlineId);
    };
    /**
     * 查询线上合同接口
     * @param contractOnlineId 线上合同ID
     */
    BlueAPI.prototype.getContractOnline = function (contractOnlineId) {
        return this.blueGatewayClient.getContractOnline(contractOnlineId);
    };
    /**
     * 线上合同状态修改接口
     * @param contractOnlineId 线上合同ID
     * @param status 合同状态：1线下协商，2待确认合同，3待上传证件，4证件审核中，5待支付费用，6待确认转账，7签约成功
     * @param updateName 修改人
     */
    BlueAPI.prototype.modifyContractStatus = function (contractOnlineId, status, updateName) {
        return this.blueGatewayClient.editContractStatus(contractOnlineId, status, updateName);
    };
    /**
     * 查询房价日历
     * @param roomId 房间ID
     * @param beginDateTime 开始时间 yyyy-MM-dd HH:mm:ss
     * @param endDateTime 结束时间 yyyy-MM-dd HH:mm:ss
     */
    BlueAPI.prototype.getCalendar = function (roomId, beginDateTime, endDateTime) {
        return this.blueGatewayClient.getCalendar(roomId, beginDateTime, endDateTime);
    };
    /**
     * 获取七牛云上传token
     * @param source  来源
     * @param isPrivate 0 公有库 1 私有库
     * @param token
     */
    BlueAPI.prototype.getUploadToken = function (params, token) {
        return this.blueGatewayClient.getUploadToken(params, token);
    };
    /**
     * 七牛私有图片转换成可访问的地址
     * @param imgUrl 七牛私有地址
     * @param token
     */
    BlueAPI.prototype.queryQiniuPrivateImageUrl = function (imgUrl, token) {
        return this.blueGatewayClient.queryQiniuPrivateImageUrl(imgUrl, token);
    };
    /**
     * 查询房间信息
     * @param ownerId 业主ID
     * @param type 查询类型 1城市
     * @param billType 账单类型	 day 日账单 month 月账单 选传
     * @param billDate 账单日期	 day 日 2018-01-01 月 2018-01 选传 2门店房型 3房间
     */
    BlueAPI.prototype.searchRoom = function (params) {
        return this.blueGatewayClient.searchRoom(params);
        // return this.blueGatewayClient.searchRoom(ownerId, type, billType, billDate);
    };
    /**
     * 中转接口。以前迁移后有问题需中转的接口
     * @param params 接口参数
     * @param url 请求的地址
     * @param method 请求的方法
     */
    BlueAPI.prototype.redirectUrl = function (params, url, method) {
        return this.blueGatewayClient.redirectUrl(params, url, method);
    };
    /**
     * 查询省
     */
    BlueAPI.prototype.getProvince = function () {
        return this.blueGatewayClient.getProvince();
    };
    /**
     * 查询市区
     */
    BlueAPI.prototype.getCitys = function (id) {
        return this.blueGatewayClient.getCitys(id);
    };
    /**
     * 查询乡镇
     */
    BlueAPI.prototype.getCountys = function (id) {
        return this.blueGatewayClient.getCountys(id);
    };
    /**
     * ruby中转接口。
     * @param params 接口参数
     * @param url 请求的地址
     * @param method 请求的方法
     */
    BlueAPI.prototype.rubyRedirectUrl = function (params, url, method) {
        return this.blueGatewayClient.rubyRedirectUrl(params, url, method);
    };
    return BlueAPI;
}());
exports.BlueAPI = BlueAPI;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/blue-api.js
// module id = 150
// module chunks = 44